import { jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { formatTimeforDVRDisplay } from "../../../../lib/videoUtils.js";
import { useVideoTime } from "../../../VideoContextProvider/context/state/time.js";
/* empty css           */
const Time = ({ isVOD = false }) => {
  const { isAtLiveEdge, position, seekableRange } = useVideoTime();
  const { end } = seekableRange;
  const [time, setTime] = useState(0);
  const [formattedTime, setFormattedTime] = useState("00:00");
  const formattedEndTime = formatTimeforDVRDisplay(end);
  const formattedCurrentPositionTime = formatTimeforDVRDisplay(position);
  useEffect(() => {
    const timeFromLive = end - position;
    const timeDelta = timeFromLive - time;
    if (timeDelta > 1 || timeDelta < -1) {
      setTime(timeFromLive);
      setFormattedTime(`-${formatTimeforDVRDisplay(timeFromLive)}`);
    }
    if (isAtLiveEdge) {
      setFormattedTime("");
    }
  }, [end, isAtLiveEdge, position, time]);
  return /* @__PURE__ */jsx("span", { className: "omega_time", "data-testid": "time", children: isVOD ?
    // this will display the current position and actual video duration for vod. Ex: 04:04 / 42:30
    `${formattedCurrentPositionTime} / ${formattedEndTime}` :
    `${formattedTime}` });
};
export {
  Time };
//# sourceMappingURL=dist/components/VideoContainer/VideoControlRack/Time/index.js.map